export default {
    title: "Import clients",
    upload_label: "Please upload a .csv file following this model:",
    loading_message: "Sending data, this may take a few minutes...",
    file_size_error: "The file must be up to {0}MB",
    csv_error: "An error occurred while reading the CSV, check if the file is valid",
    include_time: "Includes time too",
    format: "Format",
    decimal_separator: "Decimal Separator",
    full_name: "Contains full name",
    default_prefix: "Default area code",
    update_profiles: "Update profiles",
    summary: {
        new_clients: "New clients",
        updated_clients: "Updated clients",
    },
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    import: "Import",
    close: "Close",
    queued_message: "Import submitted! It will be processed in the background.",
    queued_link: "Track it in the import history",
    open_button: "Import clients",
    columns: {
        client_external_id: "Client Id",
        first_name: "First name",
        last_name: "Last name",
        whatsapp: "Phone",
        email: "Email",
        birthdate: "Birthdate",
    },
};
